import { Star } from "lucide-react";

const CelebritiesSection = () => {
  const celebrities = [
    {
      name: "Isha Sanjay",
      role: "Actress - Marathi TV Serial",
      image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2",
    },
    {
      name: "Danny Pandit",
      role: "Creator",
      image: "https://images.unsplash.com/photo-1594465919760-441fe5908ab0",
    },
    {
      name: "Purva Shinde",
      role: "Actress",
      image: "https://images.unsplash.com/photo-1653641621097-d25366c2c6a4",
    },
    {
      name: "Rinku Rajguru",
      role: "Movie Actress",
      image: "https://images.unsplash.com/photo-1653640869615-e9878a2c8344",
    },
  ];

  return (
    <section
      id="celebrities"
      className="py-24 bg-stone-900 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
            backgroundSize: "40px 40px",
          }}
        ></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <Star className="w-12 h-12 text-rose-400 mx-auto mb-4" />
          <p className="text-rose-400 text-sm font-medium tracking-wider uppercase mb-2">
            Celebrity Clients
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
            Trusted By Celebrities
          </h2>
          <p className="text-stone-300 max-w-2xl mx-auto">
            Honored to be part of the team and work with renowned personalities
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {celebrities.map((celebrity, index) => (
            <div key={index} className="group">
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] mb-4">
                <img
                  src={celebrity.image}
                  alt={celebrity.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    {celebrity.name}
                  </h3>
                  <p className="text-rose-300 text-sm font-medium">
                    {celebrity.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CelebritiesSection;
